import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const Chip = ({ value, label, color, t }) => (
  <Box sx={{
    display: "flex", flexDirection: "column", alignItems: "flex-start",
    padding: "12px 20px",
    border: `1px solid ${t.border2}`,
    borderRadius: "4px",
    minWidth: "90px",
    background: t.surface,
  }}>
    <Typography sx={{
      fontFamily: "'Inter', sans-serif",
      fontSize: "26px", fontWeight: 700,
      color: color, lineHeight: 1,
      letterSpacing: "-0.02em",
    }}>
      {value ?? "—"}
    </Typography>
    <Typography sx={{
      fontFamily: "'DM Mono', monospace",
      fontSize: "8px", letterSpacing: "0.12em",
      textTransform: "uppercase", color: t.text3,
      mt: "4px",
    }}>
      {label}
    </Typography>
  </Box>
);

const StatChips = ({ summary }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box sx={{ display: "flex", gap: "8px", padding: "16px 20px", flexWrap: "wrap" }}>
    <Chip value={summary?.totalAssociates}      label="Total"        color={t.text2}  t={t} />
    <Chip value={summary?.billable}             label="Billable"     color={t.text2}  t={t} />
    <Chip value={summary?.fullyAllocated}       label="Full Alloc."  color={t.accent} t={t} />
    <Chip value={summary?.partiallyAllocated}   label="Partial"      color={t.gold}   t={t} />
    <Chip value={summary?.billedAssociates}     label="Bil Associates"      color={t.accent}   t={t} />
    <Chip value={summary?.unBilledAssociates}   label="UBL Associates"      color={t.gold}   t={t} />
    <Chip value={summary?.newPendingAllocation} label="⚑ New"       color={t.accent} t={t} />
    <Chip value={summary?.available}            label="Available"    color={t.accent} t={t} />
    <Chip value={summary?.nonBillable}          label="Non-Billable" color={t.gold}   t={t} />
  </Box>
  );
};

export default StatChips;